var _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFolderError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.778c0 .324-.148.635-.41.864a1.51 1.51 0 01-.99.358H4.4a1.51 1.51 0 01-.99-.358 1.15 1.15 0 01-.41-.864V5.222c0-.324.147-.635.41-.864A1.51 1.51 0 014.4 4h3.5l1.4 1.833h6.3c.371 0 .727.13.99.358.262.23.41.54.41.865v6.722z",
    stroke: "#8E8E8F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 3,
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14l-2 2M15 14l2 2",
    stroke: "#fff",
    strokeWidth: 0.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}

export default SvgIconFolderError;